/**
 * ArtWorkSpecs Queries
 */
import gql from 'graphql-tag'

export const getColorsQuery = gql`
  query GetColors {
    colorsResult: getColors {
      colors
      stitchingColors: stitching_colors
    }
  }
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/screens/ArtworkSpecs/data.ts